import * as z from "zod";

const TicketDataForAssignment_ = z.object({
  linearTicketId: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  labels: z.array(z.string()),
  comments: z.array(z.object({ author: z.string(), body: z.string() })),
  creatorName: z.string().nullable(),
  currentTeamKey: z.string().nullable(),
});

export const TicketDataForAssignment: z.ZodType<TicketDataForAssignment> =
  TicketDataForAssignment_;
export interface TicketDataForAssignment extends z.infer<
  typeof TicketDataForAssignment_
> {}

const ExampleAssignment_ = z.object({
  title: z.string(),
  description: z.string().nullable(),
  labels: z.array(z.string()),
  teamKey: z.string(),
});

export const ExampleAssignment: z.ZodType<ExampleAssignment> =
  ExampleAssignment_;
export interface ExampleAssignment extends z.infer<typeof ExampleAssignment_> {}

const TeamAssignment_ = z.object({
  linearTicketId: z.string(),
  suggestedTeamKey: z.string(),
  confidence: z.enum(["high", "medium", "low"]),
  reasoning: z.string(),
});

export const TeamAssignment: z.ZodType<TeamAssignment> = TeamAssignment_;
export interface TeamAssignment extends z.infer<typeof TeamAssignment_> {}

export const autoAssignTicketTeam = {
  name: "autoAssignTicketTeam" as const,
  input: z.object({
    tickets: z.array(TicketDataForAssignment),
    examples: z.array(ExampleAssignment),
  }),
  output: z.object({
    assignments: z.array(TeamAssignment),
    error: z.string().nullable(),
  }),
};
